const defaultValueRangeModel = {
  operator: "less",
  value: {}
};
export {
  defaultValueRangeModel
};
//# sourceMappingURL=types.js.map
